// eslint-disable-next-line import/prefer-default-export
export const MY_PERMISSIONS_PAYLOAD_OK = [{
  group: 'administrators',
  role: ['superuser', 'managePages', 'editUser'],
}, {
  group: 'master',
  role: ['editUserProfile', 'managePages'],
}];
